import type { ReactNode } from "react";
import { Loader } from "../Components";

interface Props {
  loading: boolean;
  children: ReactNode;
}
const LoaderContainer = ({ loading, children }: Props) => {
  if (loading) {
    return <Loader />;
  }
  return <>{children}</>;
};

export default LoaderContainer;
